// extracted by mini-css-extract-plugin
export var button = "button-module--button--77797";
export var disabled = "button-module--disabled--ef3ca";
export var primary = "button-module--primary--b978b";
export var secondary = "button-module--secondary--5c365";
export var tertiary = "button-module--tertiary--4116e";